'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Promotions = void 0;
var transport_1 = require("../../transport");
var Promotions = /** @class */ (function () {
    function Promotions() {
    }
    Promotions.prototype.filter = function (params) {
        return transport_1.transport.request('promotions/filter', params);
    };
    Promotions.prototype.optIn = function (params) {
        return transport_1.transport.request('promotions/optIn', params);
    };
    Promotions.prototype.getByCatId = function (params) {
        return transport_1.transport.request('promotions/getByCatId', params);
    };
    Promotions.prototype.getCategories = function (params) {
        return transport_1.transport.request('promotionCategories/get', params);
    };
    return Promotions;
}());
exports.Promotions = Promotions;
